import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import CargaMasivaArticulos from "./CargaMasivaArticulos";

function ListadoArticulosMaster() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;

  const [articulosAll, setArticulosAll] = useState([]);
  const [masters, setMasters] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [marcas, setMarcas] = useState([]);

  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedMarca, setSelectedMarca] = useState("");

  const [comments2, setComments2] = useState([]);
  const [loader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const [modalVariantes, setModalVariantes] = useState(false);
  const [selectedMasterName, setSelectedMasterName] = useState("");
  const [variantesShown, setVariantesShown] = useState([]);
  const toggleVariantes = () => setModalVariantes(!modalVariantes);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [editId, setEditId] = useState("");
  const [editSKU, setEditSKU] = useState("");
  const [editMLM, setEditMLM] = useState("");
  const [editCodigo, setEditCodigo] = useState("");
  const [editNombre, setEditNombre] = useState("");
  const [editLinea, setEditLinea] = useState("");
  const [editMarca, setEditMarca] = useState("");
  const [guardandoEdit, setGuardandoEdit] = useState(false);

  const ITEMS_PER_PAGE = 50;
  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Cargando masters...",
    });
  }

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => {
        const all = res.data || [];
        setArticulosAll(all);

        // count variantes per master _id
        const variantCountByPadre = new Map();
        const idsTikTokByPadre = new Map();
        for (const a of all) {
          const padreId = a.articuloPadre?._id || a.articuloPadre;
          if (padreId) {
            const key = String(padreId);
            variantCountByPadre.set(key, (variantCountByPadre.get(key) || 0) + 1);
            idsTikTokByPadre.set(key, `${idsTikTokByPadre.get(key) || ""},${a.skuTikTok || ""}`);
          }
        }

        const onlyMasters = all
          .filter((a) => a.modelo === "MASTER")
          .map((a) => ({
            _id: a._id,
            idArticulo: a.idArticulo,
            codigo: a.codigo,
            SKU: a.SKU || "",
            MLM: a.MLM || "",
            skuTikTok: `${a.skuTikTok || ""},${idsTikTokByPadre.get(String(a._id)) || ""}`,
            nombre: a.nombre || "",
            modelo: a.modelo || "",
            observaciones: a.observaciones || "",
            idLinea: a.lineas?.[0]?._id || a.lineas?.[0] || "",
            linea: a.lineas?.[0]?.name || "",
            idMarca: a.marcas?.[0]?._id || a.marcas?.[0] || "",
            marca: a.marcas?.[0]?.name || "",
            variantes: variantCountByPadre.get(String(a._id)) || 0,
          }));

        setMasters(onlyMasters);
        setCargando(false);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
      });

    axios
      .get(URL_LINEAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setLineas(res.data || []))
      .catch((err) => console.log(err));

    axios
      .get(URL_MARCAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setMarcas(res.data || []))
      .catch((err) => console.log(err));
  }, [user]);

  const abrirVariantes = (master) => {
    const variantesList = articulosAll
      .filter((a) => {
        const padreId = a.articuloPadre?._id || a.articuloPadre;
        return String(padreId) === String(master._id);
      })
      .map((a) => ({
        SKU: a.SKU || "",
        nombre: a.nombre || "",
        modelo: a.modelo || "",
      }));
    setVariantesShown(variantesList);
    setSelectedMasterName(`${master.SKU} — ${master.nombre}`);
    toggleVariantes();
  };

  const abrirEdit = (master) => {
    setEditId(master._id);
    setEditSKU(master.SKU || "");
    setEditMLM(master.MLM || "");
    setEditCodigo(master.codigo || "");
    setEditNombre(master.nombre || "");
    setEditLinea(master.idLinea || "");
    setEditMarca(master.idMarca || "");
    toggleEdit();
  };

  const guardarEdit = async () => {
    if (!editCodigo || !editNombre) {
      Swal.fire({
        icon: "error",
        title: "Faltan campos",
        text: "Código y Nombre son obligatorios.",
      });
      return;
    }
    setGuardandoEdit(true);
    try {
      await axios.patch(
        `${URL_ARTICULOS}/${editId}`,
        {
          codigo: editCodigo,
          nombre: editNombre,
          SKU: editSKU || "NA",
          SKUBase: editSKU || "NA",
          MLM: editMLM || "NA",
          lineas: editLinea,
          marcas: editMarca,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      Swal.fire("Good job!", "Master actualizado con exito", "success");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      setGuardandoEdit(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${err.response?.data?.message || err.message || ""}`,
      });
    }
  };

  const eliminarMaster = async (master) => {
    if (master.variantes > 0) {
      Swal.fire({
        icon: "warning",
        title: "No se puede eliminar",
        text: `Este master tiene ${master.variantes} variantes asociadas. Reasigna o elimina las variantes primero.`,
      });
      return;
    }
    const conf = await Swal.fire({
      title: "¿Eliminar master?",
      text: `${master.SKU} — ${master.nombre}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });
    if (!conf.isConfirmed) return;
    try {
      await axios.patch(
        `${URL_ARTICULOS}/${master._id}`,
        { is_active: "No" },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      Swal.fire("Eliminado", "Master dado de baja", "success");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error", text: err.message });
    }
  };

  function PDFTabla() {
    const data = comments2.map((a) => [a.SKU, a.MLM, a.codigo, a.nombre, a.marca, a.linea, a.variantes]);
    const doc = new jsPDF("landscape", "mm", "a4", true);
    doc.text("Listado de Artículos Master", 20, 20);
    doc.autoTable({
      head: [["SKU", "MLM", "Código", "Nombre", "Marca", "Línea", "# Variantes"]],
      body: data,
      startY: 30,
    });
    doc.save("ArticulosMaster.pdf");
  }

  function excel() {
    const data = comments2.map((a) => ({
      SKU: a.SKU,
      MLM: a.MLM,
      Codigo: a.codigo,
      Nombre: a.nombre,
      Marca: a.marca,
      Linea: a.linea,
      Variantes: a.variantes,
    }));
    const option = {
      fileName: "ArticulosMaster",
      datas: [
        {
          sheetData: data,
          sheetName: "Masters",
          sheetFilter: ["SKU", "MLM", "Codigo", "Nombre", "Marca", "Linea", "Variantes"],
          sheetHeader: ["SKU", "MLM", "Código", "Nombre", "Marca", "Línea", "# Variantes"],
        },
      ],
    };
    new ExportJsonExcel(option).saveExcel();
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "MLM", field: "MLM", sortable: true },
    { name: "Código", field: "codigo", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Línea", field: "linea", sortable: true },
    { name: "# Variantes", field: "variantes", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computed = masters;

    if (search) {
      const s = search.toLowerCase();
      computed = computed.filter(
        (m) =>
          m.SKU.toLowerCase().includes(s) ||
          m.skuTikTok.includes(search.trim()) ||
          (m.MLM || "").toLowerCase().includes(s) ||
          m.codigo.toLowerCase().includes(s) ||
          m.nombre.toLowerCase().includes(s) ||
          m.marca.toLowerCase().includes(s) ||
          m.linea.toLowerCase().includes(s)
      );
    }
    if (selectedLinea) {
      computed = computed.filter((m) => String(m.idLinea) === String(selectedLinea));
    }
    if (selectedMarca) {
      computed = computed.filter((m) => String(m.idMarca) === String(selectedMarca));
    }

    setTotalItems(computed.length);
    setComments2(computed);

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      const numericFields = ["variantes"];
      if (numericFields.includes(sorting.field)) {
        computed = [...computed].sort(
          (a, b) => reversed * (parseFloat(a[sorting.field]) - parseFloat(b[sorting.field]))
        );
      } else {
        computed = [...computed].sort(
          (a, b) =>
            reversed * String(a[sorting.field] || "").localeCompare(String(b[sorting.field] || ""))
        );
      }
    }

    return computed.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  }, [masters, search, selectedLinea, selectedMarca, sorting, currentPage]);

  function limpiarSearch() {
    setSearch("");
    setSelectedLinea("");
    setSelectedMarca("");
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_articulos ? (
        <div className="card col-12">
          <Row>
            <Col md={6}>
              <Button href="/MenuArticulos" size="sm" className="btn btn-danger" id="botonListado">
                Regresar
              </Button>{" "}
              <Button href="/ArticulosMasterCreate" size="sm" className="btn btn-success">
                <i className="fas fa-plus"></i> Crear Master
              </Button>{" "}
              <CargaMasivaArticulos />
            </Col>
            <Col sm={6}>
              <ButtonGroup id="logoutBoton">
                <Button size="sm" color="danger" onClick={PDFTabla}>
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button size="sm" color="primary" onClick={excel}>
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Artículos Master</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-2 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
            <div className="col-md-2">
              <Button size="sm" color="info" onClick={limpiarSearch}>
                Limpiar
              </Button>
            </div>
          </div>

          <Row>
            <Col md={3}>
              <Label>Línea</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedLinea}
                onChange={(e) => {
                  setSelectedLinea(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((l) => (
                    <option value={l._id} key={l._id}>
                      {l.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={3}>
              <Label>Marca</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todas</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((m) => (
                    <option value={m._id} key={m._id}>
                      {m.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((m) => (
                <tr key={m._id}>
                  <td>{m.SKU}</td>
                  <td>{m.MLM}</td>
                  <td>{m.codigo}</td>
                  <td>{m.nombre}</td>
                  <td>{m.marca}</td>
                  <td>{m.linea}</td>
                  <td>
                    <span className="badge badge-info">{m.variantes}</span>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      color="success"
                      href={`/ArticulosCreate?padre=${m._id}`}
                      title="Agregar variante a este master"
                    >
                      <i className="fas fa-plus"></i> Variante
                    </Button>{" "}
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => abrirVariantes(m)}
                      disabled={m.variantes === 0}
                    >
                      <i className="fas fa-eye"></i> Variantes
                    </Button>{" "}
                    <Button size="sm" color="primary" onClick={() => abrirEdit(m)} title="Editar master">
                      <i className="far fa-edit"></i>
                    </Button>{" "}
                    <Button size="sm" color="danger" onClick={() => eliminarMaster(m)}>
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modalVariantes} toggle={toggleVariantes}>
        <ModalHeader toggle={toggleVariantes}>
          <h4>Variantes de: {selectedMasterName}</h4>
        </ModalHeader>
        <ModalBody>
          <Table size="sm" striped>
            <thead>
              <tr>
                <th>SKU</th>
                <th>Variante (modelo)</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              {variantesShown.map((v, idx) => (
                <tr key={idx}>
                  <td>{v.SKU}</td>
                  <td>{v.modelo}</td>
                  <td>{v.nombre}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleVariantes}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar Artículo Master</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Código *</Label>
              <Input
                type="text"
                value={editCodigo}
                required
                onChange={(e) => setEditCodigo(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>SKU</Label>
              <Input
                type="text"
                value={editSKU}
                onChange={(e) => setEditSKU(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>MLM</Label>
              <Input
                type="text"
                placeholder="MLM"
                value={editMLM}
                onChange={(e) => setEditMLM(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Nombre *</Label>
              <Input
                type="text"
                value={editNombre}
                required
                onChange={(e) => setEditNombre(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Línea</Label>
              <Input
                type="select"
                value={editLinea}
                onChange={(e) => setEditLinea(e.target.value)}
              >
                <option value="">Selecciona línea</option>
                {lineas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((l) => (
                    <option value={l._id} key={l._id}>
                      {l.name}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Marca</Label>
              <Input
                type="select"
                value={editMarca}
                onChange={(e) => setEditMarca(e.target.value)}
              >
                <option value="">Selecciona marca</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((m) => (
                    <option value={m._id} key={m._id}>
                      {m.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarEdit} disabled={guardandoEdit}>
            Guardar
          </Button>
          <Button color="secondary" onClick={toggleEdit}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoArticulosMaster;
